// Turn a race track outline ([[lat, lng], ...] from race.trackOutline) into an
// SVG path fitted to a card-sized viewBox.
//
// A degree of longitude is shorter than a degree of latitude, by cos(latitude).
// Without that correction Norwegian tracks render noticeably stretched sideways.
export function trackPath(points, width = 200, height = 96, padding = 8) {
    const valid = (Array.isArray(points) ? points : []).filter(point => Array.isArray(point)
        && Number.isFinite(point[0])
        && Number.isFinite(point[1]));
    if (valid.length < 2) {
        return '';
    }

    const lats = valid.map(point => point[0]);
    const lngs = valid.map(point => point[1]);
    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLng = Math.min(...lngs);
    const maxLng = Math.max(...lngs);
    const lngScale = Math.cos((((minLat + maxLat) / 2) * Math.PI) / 180);

    // Guard against a zero span (all points identical) producing NaN.
    const spanX = Math.max((maxLng - minLng) * lngScale, 1e-9);
    const spanY = Math.max(maxLat - minLat, 1e-9);
    const innerWidth = Math.max(width - (padding * 2), 1);
    const innerHeight = Math.max(height - (padding * 2), 1);
    const scale = Math.min(innerWidth / spanX, innerHeight / spanY);
    const offsetX = padding + ((innerWidth - (spanX * scale)) / 2);
    const offsetY = padding + ((innerHeight - (spanY * scale)) / 2);

    return valid.map((point, idx) => {
        const x = offsetX + ((point[1] - minLng) * lngScale * scale);
        // SVG y grows downward, so invert latitude to put north up.
        const y = offsetY + ((maxLat - point[0]) * scale);
        return `${idx === 0 ? 'M' : 'L'}${x.toFixed(1)} ${y.toFixed(1)}`;
    }).join(' ');
}

export default trackPath;
